<template>
    <v-hover>
        <v-navigation-drawer
            id="app-drawer"
            v-model="visible"
            app
            dark
            slot-scope="{ hover }"
            :mini-variant="shouldMinimizeDrawer(hover)"
            hide-overlay
            stateless
        >
            <v-img :src="image" class="navigation-scrollable">
                <v-layout class="fill-height" tag="v-list" column>
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <v-img :src="logo" height="55" contain />
                        </v-list-tile-avatar>
                        <v-list-tile-content class="title-text">
                            קרן מגן שאול
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn
                                icon
                                class="mr-1"
                                @click.stop="changeDrawerMode()"
                            >
                                <v-icon color="white">mdi-view-list</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider />

                    <div v-for="(link, index) in getLinks()">
                        <v-list-tile
                            v-if="!link.sublinks"
                            :to="link.to"
                            :active-class="color"
                            avatar
                            class="v-list-item"
                        >
                            <v-list-tile-action>
                                <v-icon>{{ link.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content
                                class="link-text"
                                v-text="link.text"
                            />
                            <v-list-tile-action
                                v-if="link.subText"
                                class="caption mr-0"
                            >
                                {{ link.subText }}
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-group v-if="link.sublinks" no-action>
                            <template v-slot:activator>
                                <v-list-tile
                                    class="v-list-item drawer-group-item"
                                >
                                    <v-list-tile-action>
                                        <v-icon>{{ link.icon }}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content class="link-text">{{
                                        link.text
                                    }}</v-list-tile-content>
                                </v-list-tile>
                            </template>
                            <v-list-tile
                                v-for="(child, childIndex) in link.sublinks"
                                :to="child.to"
                                :active-class="color"
                                avatar
                                class="v-list-item"
                            >
                                <v-list-tile-action>
                                    <v-icon v-text="child.icon"></v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content
                                    class="link-text"
                                    v-text="child.text"
                                ></v-list-tile-content>

                                <v-list-tile-action
                                    v-if="child.subText"
                                    class="caption mr-0"
                                >
                                    {{ child.subText }}
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list-group>
                    </div>

                    <v-layout align-end>
                        <v-layout column>
                            <v-divider class="mb-0" />
                            <v-list-tile
                                @click="logOut"
                                class="v-list-item mb-2 pl-0"
                            >
                                <v-list-tile-action class="mr-2">
                                    <v-icon>mdi-power</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content class="link-text">
                                    Log Out
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-layout>
                    </v-layout>
                </v-layout>
            </v-img>
        </v-navigation-drawer>
    </v-hover>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";
import paths from "../../router/paths";

export default {
    data: () => ({
        logo:
            "https://broadcastmessages.blob.core.windows.net/images/kerenmagenshuil.jpg",
        links: [
            {
                to: "/accounts",
                icon: "mdi-account",
                text: "Accounts",
            },
            {
                to: "/transactions",
                icon: "mdi-currency-usd",
                text: "Transactions",
            },
        ],
        responsive: false,
        mini: false,
    }),
    watch: {
        responsive(newValue, oldValue) {
            this.mini = newValue;
        },
    },
    computed: {
        ...mapState("app", ["image", "color"]),
        visible: {
            get() {
                return this.showDrawer();
            },
            set(val) {
                this.setDrawer(val);
            },
        },
        items() {
            return this.$t("Layout.View.items");
        },
    },
    async created() {},
    mounted() {
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted);
    },
    methods: {
        ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        getSubtext(link) {
            return link.subText;
        },
        showDrawer() {
            return ![null, "Login"].includes(this.$route.name);
        },
        getIsAdmin(isAdmin) {
            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        getClaims(claims) {
            if (Array.isArray(claims)) return claims;

            return claims.split(",");
        },
        getLinks() {
            // if (this.$store.state.role != "Admin")
            //     return this.links.filter((l) => ["/properties"].includes(l.to));

            return this.links;
        },
        shouldMinimizeDrawer(hover) {
            if (!this.mini) return false;

            return !hover;
        },
        changeDrawerMode(hover) {
            this.mini = !this.mini;
        },
        logOut() {
            this.$router.push({
                name: "Login",
            });
        },
    },
};
</script>

<style lang="scss">
#app-drawer {
    .v-list__tile {
        border-radius: 4px;

        &--buy {
            margin-top: auto;
            margin-bottom: 17px;
        }
    }

    .v-image__image--contain {
        top: 9px;
        height: 60%;
    }

    .search-input {
        margin-bottom: 30px !important;
        padding-left: 15px;
        padding-right: 15px;
    }
}

.link-text {
    font-weight: 300;
    font-size: 14px !important;
    margin-bottom: 5px;
    margin-top: 5px;
}

.title-text {
    font-weight: 400;
    font-size: 18px !important;
    margin-bottom: 5px;
    margin-top: 5px;
    font-family: Roboto, sans-serif !important;
    line-height: 1 !important;
}

.navigation-scrollable {
    background: rgb(238, 174, 202);
    background: radial-gradient(circle, #f0f0f0 0%, #fff 100%);
    overflow-y: auto !important;
    overflow-x: hidden !important;
}

.drawer-group-item:hover {
    background-color: #424242 !important;
    box-shadow: none !important;
}
</style>
